import http from "../http-common-auth";

class AuthService {
  /** Password login: `username` may be account username or email (backend accepts both). */
  login(username, password) {
    return http
      .post("signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  /**
   * Google OAuth Sign-In
   * @param {string} credential - The Google ID token
   */
  googleAuth(credential) {
    return http
      .post("google", { credential })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  sendSignupOtp(email, institutionId) {
    return http.post("signup/send-otp", { email, institutionId });
  }

  register(username, email, password, otp) {
    return http.post("signup", {
      username,
      email,
      password,
      otp,
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }

  updateCurrentUserProfile(profileImageUrl) {
    const user = this.getCurrentUser();
    if (user) {
      user.profileImageUrl = profileImageUrl;
      localStorage.setItem("user", JSON.stringify(user));
    }
  }

  /**
   * Validate current session token with server
   * Returns true if token is valid, false otherwise
   */
  async validateToken() {
    try {
      const response = await http.get("validate");
      return response.status === 200;
    } catch (error) {
      const status = error.response?.status;
      // Only treat definitive auth failure as invalid. Network/5xx errors must not log the user out.
      if (status === 401) {
        return false;
      }
      return true;
    }
  }

  /**
   * Extend session: new JWT, same tokenVersion. Server must still accept current token.
   */
  async refreshToken() {
    const response = await http.post("refresh");
    const data = response.data;
    if (data?.accessToken) {
      const prev = this.getCurrentUser() || {};
      localStorage.setItem("user", JSON.stringify({ ...prev, ...data }));
    }
    return data;
  }

  /**
   * Change password for current user
   * @param {string} currentPassword - Current password for verification
   * @param {string} newPassword - New password to set
   */
  changePassword(currentPassword, newPassword) {
    return http.post("change-password", {currentPassword,newPassword});
  }

  /**
   * Get the Google Workspace SSO authorize URL for an institution.
   * The frontend should redirect the browser to the returned URL.
   */
  ssoAuthorize(institutionId) {
    return http.get(`sso/authorize?institutionId=${institutionId}`);
  }

  /**
   * Exchange the Google OAuth code for a Typogram JWT via SSO callback.
   */
  ssoCallback(code, institutionId) {
    return http
      .post("sso/callback", { code, institutionId: String(institutionId) })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }
}

const authService = new AuthService();
export default authService;
